type IGlobalSearchFiltersKeys = 'sortBy' | 'employmentTypes' | 'careerLevels' | 'benefits' | 'domains' | 'spokenLanguages' | 'remote';
type IGlobalSearchFiltersObject = { [K in IGlobalSearchFiltersKeys]: ISearchFiltersObject } & { [k: string]: ISearchFiltersObject };

export interface ISearchFiltersObject {
  apiParameter: string;
  label: string;
  order: number;
  valueAsArray?: boolean,
  fields: {
    filtersLabel: string; // translation key
    defaultValue: string | number; // field value
    slug?: string; // translation key - the string that is added in URL
  }[]
}

export const SEARCH_FORM_FILTERS_OBJECT: IGlobalSearchFiltersObject = {
  sortBy: {
    apiParameter: 'sort',
    label: 'global.label.order-by',
    order: 1,
    fields: [
      {
        filtersLabel: 'order-by-relevance',
        defaultValue: '',
        slug: '',
      },
      {
        filtersLabel: 'order-by-salary',
        defaultValue: 'salary',
        slug: 'salary',
      },
      {
        filtersLabel: 'order-by-recency',
        defaultValue: 'recent',
        slug: 'recent',
      },
      {
        filtersLabel: 'order-by-distance',
        defaultValue: 'distance',
        slug: 'distance',
      },
    ],
  },
  employmentTypes: {
    apiParameter: 'employmentTypes',
    label: 'job_search.filter.work_preferences',
    order: 2,
    valueAsArray: true,
    fields: [
      {
        filtersLabel: 'global.job.employment_type.fulltime',
        defaultValue: '1',
        slug: 'full-time',
      },
      {
        filtersLabel: 'global.job.employment_type.parttime',
        defaultValue: '2',
        slug: 'part-time',
      },
      {
        filtersLabel: 'global.job.employment_type.internship',
        defaultValue: '4',
        slug: 'internship',
      },
      {
        filtersLabel: 'global.job.employment_type.project',
        defaultValue: '5',
        slug: 'project',
      },
      {
        filtersLabel: 'global.job.employment_type.voluntarily',
        defaultValue: '6',
        slug: 'voluntarily',
      },
    ],
  },
  careerLevels: {
    apiParameter: 'careerLevels',
    label: 'global.filter.experience-label',
    order: 3,
    valueAsArray: true,
    fields: [
      {
        filtersLabel: 'global.filter.experience.none',
        defaultValue: '0_0',
        slug: 'no-experience',
      },
      {
        filtersLabel: 'global.filter.experience.entry',
        defaultValue: '_2',
        slug: 'entry-level',
      },
      {
        filtersLabel: 'global.filter.experience.middle',
        defaultValue: '2_5',
        slug: 'mid-level',
      },
      {
        filtersLabel: 'global.filter.experience.senior',
        defaultValue: '5_10',
        slug: 'senior-level',
      },
      {
        filtersLabel: 'global.filter.experience.executive',
        defaultValue: '10_',
        slug: 'executive-level',
      },
    ],
  },
  benefits: {
    apiParameter: 'benefits',
    label: 'global.filter.benefits',
    order: 4,
    valueAsArray: true,
    fields: [
      {
        defaultValue: '1',
        filtersLabel: 'benefit.group.financial.item1',
        slug: 'benefit-financial-1',
      },
      {
        defaultValue: '2',
        filtersLabel: 'benefit.group.financial.item2',
        slug: 'benefit-financial-2',
      },
      {
        defaultValue: '3',
        filtersLabel: 'benefit.group.financial.item3',
        slug: 'benefit-financial-3',
      },
      {
        defaultValue: '4',
        filtersLabel: 'benefit.group.financial.item4',
        slug: 'benefit-financial-4',
      },
      {
        defaultValue: '5',
        filtersLabel: 'benefit.group.financial.item5',
        slug: 'benefit-financial-5',
      },
      {
        defaultValue: '6',
        filtersLabel: 'benefit.group.financial.item6',
        slug: 'benefit-financial-6',
      },
      {
        defaultValue: '7',
        filtersLabel: 'benefit.group.financial.item7',
        slug: 'benefit-financial-7',
      },
      {
        defaultValue: '8',
        filtersLabel: 'benefit.group.financial.item8',
        slug: 'benefit-financial-8',
      },
      {
        defaultValue: '9',
        filtersLabel: 'benefit.group.financial.item9',
        slug: 'benefit-financial-9',
      },
      {
        defaultValue: '10',
        filtersLabel: 'benefit.group.medical.item1',
        slug: 'benefit-medical-1',
      },
      {
        defaultValue: '11',
        filtersLabel: 'benefit.group.medical.item2',
        slug: 'benefit-medical-2',
      },
      {
        defaultValue: '12',
        filtersLabel: 'benefit.group.development.item1',
        slug: 'benefit-development-1',
      },
      {
        defaultValue: '13',
        filtersLabel: 'benefit.group.development.item2',
        slug: 'benefit-development-2',
      },
      {
        defaultValue: '14',
        filtersLabel: 'benefit.group.development.item3',
        slug: 'benefit-development-3',
      },
      {
        defaultValue: '15',
        filtersLabel: 'benefit.group.development.item4',
        slug: 'benefit-development-4',
      },
      {
        defaultValue: '16',
        filtersLabel: 'benefit.group.workplace.item1',
        slug: 'benefit-workplace-1',
      },
      {
        defaultValue: '17',
        filtersLabel: 'benefit.group.workplace.item2',
        slug: 'benefit-workplace-2',
      },
      {
        defaultValue: '18',
        filtersLabel: 'benefit.group.workplace.item3',
        slug: 'benefit-workplace-3',
      },
      {
        defaultValue: '19',
        filtersLabel: 'benefit.group.workplace.item4',
        slug: 'benefit-workplace-4',
      },
      {
        defaultValue: '20',
        filtersLabel: 'benefit.group.workplace.item5',
        slug: 'benefit-workplace-5',
      },
      {
        defaultValue: '21',
        filtersLabel: 'benefit.group.workplace.item6',
        slug: 'benefit-workplace-6',
      },
      {
        defaultValue: '22',
        filtersLabel: 'benefit.group.workplace.item7',
        slug: 'benefit-workplace-7',
      },
      {
        defaultValue: '23',
        filtersLabel: 'benefit.group.workplace.item8',
        slug: 'benefit-workplace-8',
      },
      {
        defaultValue: '24',
        filtersLabel: 'benefit.group.workplace.item9',
        slug: 'benefit-workplace-9',
      },
      {
        defaultValue: '25',
        filtersLabel: 'benefit.group.free_time.item1',
        slug: 'benefit-freetime-1',
      },
      {
        defaultValue: '26',
        filtersLabel: 'benefit.group.free_time.item2',
        slug: 'benefit-freetime-2',
      },
      {
        defaultValue: '27',
        filtersLabel: 'benefit.group.free_time.item3',
        slug: 'benefit-freetime-3',
      },
    ],
  },
  domains: {
    apiParameter: 'domain',
    label: 'global.filter.domains',
    order: 1,
    valueAsArray: true,
    fields: [
      {
        defaultValue: '8',
        filtersLabel: 'domain.administration',
        slug: 'administration',
      },
      {
        defaultValue: '16',
        filtersLabel: 'domain.agriculture',
        slug: 'agriculture',
      },
      {
        defaultValue: '17',
        filtersLabel: 'domain.security',
        slug: 'security',
      },
      {
        defaultValue: '12',
        filtersLabel: 'domain.babysitter.clean',
        slug: 'babysitter',
      },
      {
        defaultValue: '6',
        filtersLabel: 'domain.callcenter',
        slug: 'callcenter',
      },
      {
        defaultValue: '4',
        filtersLabel: 'domain.construction',
        slug: 'construction',
      },
      {
        defaultValue: '7',
        filtersLabel: 'domain.finance',
        slug: 'finance',
      },
      {
        defaultValue: '13',
        filtersLabel: 'domain.education',
        slug: 'education',
      },
      {
        defaultValue: '14',
        filtersLabel: 'domain.engineering',
        slug: 'engineering',
      },
      {
        defaultValue: '9',
        filtersLabel: 'domain.it',
        slug: 'it',
      },
      {
        defaultValue: '20',
        filtersLabel: 'domain.legislators',
        slug: 'legislators',
      },
      {
        defaultValue: '19',
        filtersLabel: 'domain.management',
        slug: 'management',
      },
      {
        defaultValue: '10',
        filtersLabel: 'domain.marketing',
        slug: 'marketing',
      },
      {
        defaultValue: '15',
        filtersLabel: 'domain.medicine',
        slug: 'medicine',
      },
      {
        defaultValue: '5',
        filtersLabel: 'domain.production',
        slug: 'production',
      },
      {
        defaultValue: '18',
        filtersLabel: 'domain.hr',
        slug: 'hr',
      },
      {
        defaultValue: '70',
        filtersLabel: 'domain.retail',
        slug: 'retail',
      },
      {
        defaultValue: '11',
        filtersLabel: 'domain.beauty',
        slug: 'beauty',
      },
      {
        defaultValue: '2',
        filtersLabel: 'domain.transportation',
        slug: 'transportation',
      },
      {
        defaultValue: '21',
        filtersLabel: 'domain.technician',
        slug: 'technician',
      },
      {
        defaultValue: '24',
        filtersLabel: 'domain.sportart',
        slug: 'sportart',
      },
      {
        defaultValue: '3',
        filtersLabel: 'domain.horeca',
        slug: 'horeca',
      },
      {
        defaultValue: '1',
        filtersLabel: 'domain.sales',
        slug: 'sales',
      },
      {
        defaultValue: '23',
        filtersLabel: 'domain.others',
        slug: 'others',
      },
    ],
  },
  spokenLanguages: {
    apiParameter: 'spokenLanguages',
    label: 'global.filter.spoken_lang',
    order: 5,
    valueAsArray: true,
    fields: [
      {
        defaultValue: 'ar',
        filtersLabel: 'Arabă',
        slug: 'araba',
      },
      {
        defaultValue: 'bg',
        filtersLabel: 'Bulgară',
        slug: 'bulgara',
      },
      {
        defaultValue: 'cs',
        filtersLabel: 'Cehă',
        slug: 'ceha',
      },
      {
        defaultValue: 'da',
        filtersLabel: 'Daneză',
        slug: 'daneza',
      },
      {
        defaultValue: 'de',
        filtersLabel: 'Germană',
        slug: 'germana',
      },
      {
        defaultValue: 'el',
        filtersLabel: 'Greacă',
        slug: 'greaca',
      },
      {
        defaultValue: 'en',
        filtersLabel: 'Engleză',
        slug: 'engleza',
      },
      {
        defaultValue: 'es',
        filtersLabel: 'Spaniolă',
        slug: 'spaniola',
      },
      {
        defaultValue: 'fi',
        filtersLabel: 'Finlandeză',
        slug: 'finlandeza',
      },
      {
        defaultValue: 'fr',
        filtersLabel: 'Franceză',
        slug: 'franceza',
      },
      {
        defaultValue: 'he',
        filtersLabel: 'Ebraică',
        slug: 'ebraica',
      },
      {
        defaultValue: 'hr',
        filtersLabel: 'Croată',
        slug: 'croata',
      },
      {
        defaultValue: 'hu',
        filtersLabel: 'Maghiară',
        slug: 'maghiara',
      },
      {
        defaultValue: 'it',
        filtersLabel: 'Italiană',
        slug: 'italiana',
      },
      {
        defaultValue: 'ja',
        filtersLabel: 'Japoneză',
        slug: 'japoneza',
      },
      {
        defaultValue: 'ko',
        filtersLabel: 'Coreeană',
        slug: 'coreeana',
      },
      {
        defaultValue: 'lv',
        filtersLabel: 'Letonă',
        slug: 'letona',
      },
      {
        defaultValue: 'nl',
        filtersLabel: 'Neerlandeză',
        slug: 'neerlandeza',
      },
      {
        defaultValue: 'no',
        filtersLabel: 'Norvegiană',
        slug: 'norvegiana',
      },
      {
        defaultValue: 'pl',
        filtersLabel: 'Poloneză',
        slug: 'poloneza',
      },
      {
        defaultValue: 'pt',
        filtersLabel: 'Portugheză',
        slug: 'portugheza',
      },
      {
        defaultValue: 'ro',
        filtersLabel: 'Română',
        slug: 'romana',
      },
      {
        defaultValue: 'ru',
        filtersLabel: 'Rusă',
        slug: 'rusa',
      },
      {
        defaultValue: 'sk',
        filtersLabel: 'Slovacă',
        slug: 'slovaca',
      },
      {
        defaultValue: 'sl',
        filtersLabel: 'Slovenă',
        slug: 'slovena',
      },
      {
        defaultValue: 'sr',
        filtersLabel: 'Sârbă',
        slug: 'sarba',
      },
      {
        defaultValue: 'sv',
        filtersLabel: 'Suedeză',
        slug: 'suedeza',
      },
      {
        defaultValue: 'tr',
        filtersLabel: 'Turcă',
        slug: 'turca',
      },
      {
        defaultValue: 'uk',
        filtersLabel: 'Ucraineană',
        slug: 'ucraineana',
      },
      {
        defaultValue: 'zh',
        filtersLabel: 'Chineză',
        slug: 'chineza',
      },
    ],
  },
  remote: {
    label: 'header.filter.remote',
    apiParameter: 'remote',
    order: 10,
    fields: [
      {
        filtersLabel: 'header.filter.remote',
        defaultValue: 1,
        slug: 'remote',
      },
    ],
  },
};
